import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { BonusLogic } from './BonusLogic';
import { GameLogic } from '../GameLogic';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';

import BonusContants from '../../Constants/BonusContants';

@Singleton
export class BonusTransformLogic extends BonusLogic {
    private _time: any;

    constructor(
        @Inject private _model: GameModel,
        @Inject private _modelEvents: ModelEvents
    ) {
        super();

        this._config = BonusContants.find(
            o => o.type === BonusTypeEnum.transform
        );
    }

    public apply(gameLogic: GameLogic): void {
        super.apply(gameLogic);

        const unit = this._model.unitList.firstOrDefault();
        const speed =
            unit.speed +
            (unit.initialSpeed / 100) * this._config.props.speedAddingPercent;

        unit.speed = speed;

        this._time = this._config.props.speedAddingTime;
    }

    public cancel(): void {
        super.cancel();

        const unit = this._model.unitList.firstOrDefault();

        unit.speed = unit.initialSpeed;

        this._time = 0;
    }

    public destroy(): void {
        super.destroy();

        const unit = this._model.unitList.firstOrDefault();

        unit.speed = unit.initialSpeed;
    }

    public update(frameTime): void {
        if (this._time > 0) {
            this._time = Math.max(0, this._time - frameTime);
        } else if (this._active) {
            this.cancel();
        }
    }

    public addTime(value): void {
        this._time += value;
    }

    public getTime(): number {
        return this._time;
    }
}
